import { renderTableTitle } from "@/utils/render.jsx";
import OverflowTooltipText from "@/components/Common/overflow-tooltip-text.vue";
import exportExcel from "@/utils/export-execel";
import dayjs from "dayjs";
export default {
  props: {
    value: {
      type: Boolean,
      default() {
        return false;
      }
    }
  },
  data() {
    const h = this.$createElement;
    return {
      options: {
        shortcuts: [{
          // lg: 近一周
          text: $t("lg2k93", "近一周"),
          value() {
            const end = new Date();
            const start = new Date();
            start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
            return [start, end];
          }
        }, {
          // lg: 近一个月
          text: $t("igtpkd4", "近一个月"),
          value() {
            const end = new Date();
            const start = new Date();
            start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
            return [start, end];
          }
        }, {
          // lg: 近三个月
          text: $t("igtw8m4", "近三个月"),
          value() {
            const end = new Date();
            const start = new Date();
            start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
            return [start, end];
          }
        }]
      },
      search: {
        uploadDate: ""
      },
      config: {
        map: {
          dataPath: "data.retVal.datas",
          totalPath: "data.retVal.totalRows",
          message: "msg"
        },
        toolBarActions: ["refresh", "fullscreen", "rowSetting"],
        format: {
          formatCurrent: "(page.current - 1) * page.pageSize"
        },
        request: "/api/file/history/page",
        table: {
          border: false
        },
        search: {
          // searchLableWidth: "200",
          searchLineNum: "2",
          value: {
            startDate: "",
            endDate: ""
          }
        },
        columns: [{
          // lg: 导入文件名称
          title: $t("q98bk56", "导入文件名称"),
          renderHeader: (h, {
            column
          }) => {
            // 使用列标题保持翻译一致，并按实际宽度决定是否显示提示。
            return renderTableTitle(column.title, column, h);
          },
          width: 200,
          key: "fileName",
          align: "center",
          notShowForm: true,
          notShowSearch: true,
          tooltip: true
        }, {
          // lg: 导入时间
          title: $t("by3bzb4", "导入时间"),
          renderHeader: (h, {
            column
          }) => {
            // 使用列标题保持翻译一致，并按实际宽度决定是否显示提示。
            return renderTableTitle(column.title, column, h);
          },
          width: 200,
          key: "uploadDate",
          align: "center",
          notShowForm: true,
          notShowSearch: false,
          renderSearch: () => {
            // lg: 开始时间 - 结束时间
            return h("DatePicker", {
              "attrs": {
                "options": this.options,
                "type": "daterange",
                "placeholder": $t("il014u4", "选择时间"),
                "editable": false
              },
              "on": {
                "on-change": () => {
                  let dates = this.search.uploadDate;
                  if (dates.length === 2) {
                    this.config.search.value.startDate = dates[0] ? `${dayjs(dates[0]).format("YYYY-MM-DD")}` : "";
                    this.config.search.value.endDate = dates[1] ? `${dayjs(dates[1]).format("YYYY-MM-DD")}` : "";
                  } else {
                    this.config.search.value.startDate = "";
                    this.config.search.value.endDate = "";
                  }
                }
              },
              "model": {
                value: this.search.uploadDate,
                callback: $$v => {
                  this.$set(this.search, "uploadDate", $$v);
                }
              }
            });
          }
        }, {
          // lg: 成功数量
          title: $t("cpv8dq4", "成功数量"),
          renderHeader: (h, {
            column
          }) => {
            // 使用列标题保持翻译一致，并按实际宽度决定是否显示提示。
            return renderTableTitle(column.title, column, h);
          },
          key: "sNumber",
          align: "center",
          width: 180,
          notShowForm: true,
          notShowSearch: true
        }, {
          // lg: 失败数量
          title: $t("bu5qib4", "失败数量"),
          renderHeader: (h, {
            column
          }) => {
            // 使用列标题保持翻译一致，并按实际宽度决定是否显示提示。
            return renderTableTitle(column.title, column, h);
          },
          key: "fNumber",
          width: 180,
          align: "center",
          notShowForm: true,
          notShowSearch: true
        }, {
          // lg: 操作
          title: $t("hkxb2", "操作"),
          renderHeader: (h, {
            column
          }) => {
            // 使用列标题保持翻译一致，并按实际宽度决定是否显示提示。
            return renderTableTitle(column.title, column, h);
          },
          key: "action",
          width: 130,
          align: "center",
          notShowSearch: true,
          notShowForm: true,
          renderTable: (h, params) => {
            if (params.row.fNumber > 0) {
              // lg: 下载失败数据
              return h("a", {
                "style": {
                  position: "relative",
                  color: "#2d8cf0",
                  display: "inline-block",
                  maxWidth: "100%",
                  minWidth: 0,
                  verticalAlign: "middle"
                },
                "on": {
                  "click": () => this.downloadExecl(params.row)
                }
              }, [params.row.loading ? h("Spin", {
                "attrs": {
                  "fix": true
                }
              }) : "", h(OverflowTooltipText, {
                "attrs": {
                  "text": $t("h1riec6", "下载失败数据"),
                  "maxWidth": 300,
                  "tooltipClass": "member-export-action-tooltip"
                }
              })]);
            } else {
              return;
            }
          }
        }]
      }
    };
  },
  computed: {
    visible: {
      get() {
        return this.value;
      },
      set(val) {
        this.$emit("input", val);
      }
    }
  },
  methods: {
    close() {
      this.search.uploadDate = "";
      this.config.search.value.startDate = "";
      this.config.search.value.endDate = "";
      this.visible = false;
    },
    downloadExecl(row) {
      exportExcel("get", `/api/file/failFileDownLoad?id=${row.id}`);
    }
  }
};